<template>
  <div>
    <el-dialog
      :title="$t('start-live.live-settings')"
      :visible.sync="showLiveSet"
      width="535px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      @close="resetForm('formLive')"
    >
      <div slot="title" class="title">
        <img src="./img/liveSet.png" style="width: 60px; height: 60px; margin-bottom: 13px" />
        {{ $t("start-live.live-settings") }}
      </div>
      <el-form
        :model="formLive"
        label-position="left"
        label-width="110px"
        :rules="rulesFrom"
        ref="formLive"
      >
        <el-form-item :label="$t('start-live.category')" prop="category">
          <el-select
            v-model="formLive.category"
            :placeholder="$t('start-live.please-select')"
            style="width: 100%"
            @change="ChangeCategory"
          >
            <el-option
              v-for="item in category"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formLive.category"
          :label="$t('start-live.secondary-category')"
          prop="region"
        >
          <el-select
            v-model="formLive.region"
            :placeholder="$t('start-live.please-select-secondary-category')"
            style="width: 100%"
            @change="handChone"
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('start-live.schedule-selection')"
          prop="match"
          v-if="formLive.category == 2"
        >
          <el-select
            v-model="formLive.match"
            filterable
            :placeholder="$t('start-live.please-select-Schedule')"
            style="width: 100%"
            @change="selectMatch"
          >
            <el-option
              v-for="(item, index) in MatchComp"
              :key="index"
              :label="item.comp"
              :value="item.comp"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('start-live.matchs')" prop="session" v-if="formLive.category == 2">
          <el-select
            v-model="formLive.session"
            :placeholder="$t('start-live.match-select')"
            style="width: 100%"
            @change="chooseSession"
          >
            <el-option
              v-for="(item, index) in dateMatch"
              :key="index"
              :label="item.home ? `${item.home}-${item.away}` : ''"
              :value="item.match_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="清晰度选择" prop="definition" v-if="formLive.category !== 1">
          <el-select v-model="formLive.definition" placeholder="请选择清晰度"  @change="chooseDefinition">
            <el-option v-for="item in definitions" :key="item.code" :label="item.label" :value="item.url"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="直播地址" style="margin-bottom: 15px" v-if="formLive.category !== 1">
          <el-input v-model.trim="formLive.liveStream" placeholder="获取直播地址"  :disabled="true"></el-input>
          <span class="append_text" @click="doCopy(formLive.liveStream)" v-if="formLive.liveStream">一键复制</span>
        </el-form-item> -->
        <el-form-item :label="$t('start-live.title')" prop="title">
          <el-input
            v-model="formLive.title"
            :placeholder="$t('start-live.please-enter-title')"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="竖版封面" v-if="formLive.category === 1" prop="imageUrl_v">
          <el-upload
            class="upload-demo upload-demo-v"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccessVertical"
            :before-upload="beforeAvatarUploadVertical"
            :headers="myHeaders"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            v-loading="upLoading_v"
          >
            <img v-if="imageUrl_v" :src="imageUrl_v" class="imgurl" style="width: 68px; height: 90px" />
            <div class="fcc" v-else>
              <i class="el-icon-circle-plus-outline" style="font-size: 30px; color: #ccc"></i>
            </div>
            <div v-if="imageUrl_v" class="del" style="left: 84px" @click.stop="removeImage(1)">删除</div>
            <div class="el-upload__text" style="left: 84px">
              <div class="size">图片尺寸：宽384*高512px</div>
              <div class="format">支持PNG/JPG格式，大小不超过5M</div>
            </div>
          </el-upload>
        </el-form-item> -->
        <el-form-item :label="$t('start-live.cover')" prop="imageUrl">
          <el-upload
            :multiple="false"
            :before-upload="beforeAvatarUpload"
            :http-request="handleUpload"
            class="upload-demo"
            :show-file-list="false"
            :auto-upload="true"
            :action="'/asd'"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            v-loading="upLoading"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              class="imgurl"
              style="width: 160px; height: 90px"
            />
            <div v-else>
              <!--
              <i class="el-icon-circle-plus-outline" style="font-size: 30px; color: #ccc"></i>
							-->
              <img width="40" src="./img/camera.png" />
              <div class="upload-text">{{ $t("start-live.upload-cover") }}</div>
            </div>
            <div v-if="imageUrl" class="del" style="left: 176px" @click.stop="removeImage(0)">
              {{ $t("start-live.delete") }}
            </div>
            <div class="el-upload__text" style="left: 176px">
              <div class="size">{{ $t("start-live.cover-size") }}</div>
              <div class="format">{{ $t("start-live.support-format") }}</div>
            </div>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="计划开播时间" prop="schedule">
          <el-date-picker value-format="timestamp"  v-model="formLive.schedule" type="datetime" placeholder="选择日期时间"> </el-date-picker>
        </el-form-item> -->

        <el-form-item :label="$t('start-live.address')">
          <span class="pull-stream">{{
            formLive.pushStream ? "******" : $t("start-live.push-address")
          }}</span>
          <span
            class="append_text"
            @click="doCopy(formLive.pushStream)"
            v-if="formLive.pushStream"
            >{{ $t("start-live.click-copy") }}</span
          >
        </el-form-item>
        <el-form-item :label="$t('start-live.key')">
          <span class="pull-stream">{{
            formLive.anchor_secret ? "******" : $t("start-live.push-key")
          }}</span>
          <span
            class="append_text"
            @click="doCopy(formLive.anchor_secret)"
            v-if="formLive.anchor_secret"
            >{{ $t("start-live.click-copy") }}</span
          >
        </el-form-item>
        <!-- <el-form-item label="高速推流" style="margin-bottom: 15px">
          <span class="pull-stream">{{ formLive.pushStream_webrtc ? "******" : $t("start-live.push-address") }}</span>
          <span class="append_text" @click="doCopy(formLive.pushStream_webrtc)" v-if="formLive.pushStream_webrtc">{{ $t("start-live.click-copy") }}</span>
        </el-form-item> -->
        <el-form-item label="高速推流开关">
          <el-switch v-model="pushStream_webrtc_toggle"></el-switch>
        </el-form-item>
        <el-form-item label="观赛券开关" v-if="this.appConfig.ticket_switch == 1">
          <el-switch v-model="ticket_toogle" @change="changeTkSwitch"></el-switch>
        </el-form-item>
        <el-form-item
          :label="$t('start-live.tickets')"
          prop="ticket"
          v-if="this.appConfig.ticket_switch == 1 && ticket_toogle"
        >
          <!-- v-model="formLive.ticket" -->
          <el-input
            v-model="formLive.ticket"
            :placeholder="$t('start-live.number-of-tickets')"
            type="number"
            pattern="/^-?\d+\.?\d*$/"
            onKeyPress="if(this.value.length==4) return false;"
            disabled
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialogs-footer">
        <div class="btn cancle-btn" @click="resetForm('formLive')">
          {{ $t("start-live.cancel") }}
        </div>
        <!-- <el-button class="btn confirm_btn" @click="createPlanLive('formLive')" :loading="loading">保存</el-button> -->
        <el-button class="btn confirm_btn" @click="confirm('formLive')" :loading="loading">{{
          $t("start-live.start")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapState } from "vuex";
import uploadByCosSdk from "@/mixins/uploadByCosSdk";

export default {
  mixins: [uploadByCosSdk],
  props: {
    isShow: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      uploadUrl: ENV === "dev" ? "/proxy/api/user/file" : API_URL + "/api/user/file",
      showLiveSet: true,
      pushStream_webrtc_toggle: false,
      ticket_toogle: false,
      formLive: {
        category: "",
        region: "",
        match: "",
        definition: "",
        liveStream: "",
        title: "",
        pushStream: "",
        anchor_secret: "",
        session: "",
        imageUrl_v: "",
        imageUrl: "",
        pushStream_webrtc: "",
        ticket: "",
        schedule: "",
      },
      imageUrl_v: "",
      imageUrl: "",
      rulesFrom: {
        category: [
          { required: true, message: this.$t("start-live.please-select"), trigger: "blur" },
        ],
        region: [
          {
            required: true,
            message: this.$t("start-live.please-select-secondary-category"),
            trigger: "change",
          },
        ],
        title: [
          { required: true, message: this.$t("start-live.please-enter-title"), trigger: "blur" },
        ],
        imageUrl_v: [{ required: true, message: "竖版封面不能为空", trigger: "change" }],
        imageUrl: [{ required: false, message: this.$t("start-live.cover"), trigger: "change" }],
        schedule: [{ required: true, message: "计划开播时间不能为空", trigger: "change" }],
        ticket: [
          {
            validator: (rule, value, callback) => {
              if (this.ticket_toogle && !value) {
                callback(new Error("观赛卷不能为空！"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      category: [],
      MatchComp: [],
      dateMatch: [],
      pushStream: "",
      liveStream: "",
      definitions: [],
      dateSession: [],
      stream: "",
      routerPath: "/",
      upLoading_v: false,
      upLoading: false,
      sportId: "",
      isClick: true,
      loading: false,
    };
  },

  computed: {
    ...mapState(["userInfo", "appConfig"]),
    categorys() {
      if (this.formLive.category) {
        let regionList = this.category.find((item) => item.id === this.formLive.category);
        return (regionList && regionList.second_category) || [];
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.getStreamInfo();
    this.inquireMatch();
    console.log(this.appConfig, "appConfig");
  },
  methods: {
    changeTkSwitch(e) {
      if (e) this.formLive.ticket = "1";
    },
    getStreamInfo() {
      post({
        // 获取推流地址
        url: "/webapi/live/getStreamInfo",
      }).then((result) => {
        if (result.status === 200) {
          const res = result.data;

          if (res.status === 0) {
            const data = res.data || {};
            this.formLive.pushStream = data.push_url;
            this.formLive.pushStream_webrtc = data.web_rtc_push_url;
            this.stream = data.stream;
            this.formLive.anchor_secret = data.anchor_secret;
          }
        }
      });
    },
    ChangeCategory(e) {
      // 通过切换直播分类获取
      this.formLive.region = "";
      this.clearData("formLive");
      this.formLive.category = e;
      if (e === 2) {
        // this.getDateMatch({});
      }
      this.getStreamInfo();
    },
    handChone(e) {
      this.formLive.match = "";
      this.formLive.session = "";
      this.dateMatch = [];
      this.dateSession = [];
      this.sportId = e;
      this.getSportMatchComp(e);
      // const selectedCategory = this.categorys.find((item) => item.id === e);
      // const { sport_type } = selectedCategory || {};
      // if (sport_type) {
      //   this.getSportMatch(selectedCategory);
      // }
    },
    selectMatch(e) {
      // this.dateSession.push(this.dateMatch[e.split(",")[1]]);
      // console.log(this.dateSession, "this.dateSession");
      this.formLive.session = "";
      this.formLive.definition = "";
      this.formLive.liveStream = "";
      this.getSportMatch(e);
    },
    doCopy(val) {
      this.$copyText(val).then(
        (e) => {
          this.$message.success(this.$t("start-live.link-copied"));
        },
        (e) => {
          this.$message.error(this.$t("start-live.copy-failed"), e.text);
        }
      );
    },
    clearData() {
      this.imageUrl = "";
      this.imageUrl_v = "";
      Object.keys(this.formLive).forEach((key) => {
        this.formLive[key] = "";
      });
      this.dateMatch = [];
      this.dateSession = [];
    },
    resetForm(formName) {
      this.clearData();
      this.$refs[formName].clearValidate();
      this.showLiveSet = false;
      this.$emit("closeDialog");
    },
    inquireMatch() {
      // 直播分类
      post({ url: "/webapi/live/getCategory" }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};
          if (res.status === 0) {
            this.category = res?.data ?? [];
            // this.formLive.category = first?.id;
          }
        }
      });
    },
    async getSportMatchComp(sportId) {
      post({
        url: "/api/match/getSportMatchComp",
        data: {
          sport_id: sportId,
        },
      }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};
          if (res.status === 0) {
            this.MatchComp = res.data?.sport_live_match_comp ?? [];
          }
        }
      });
    },
    async getSportMatch(comp) {
      post({
        url: "/api/match/getSportMatch",
        data: {
          comp: comp,
          sport_id: this.sportId,
        },
      }).then((result) => {
        if (result.status === 200) {
          console.log("getSportMatch", result);
          const res = result.data || {};
          if (res.status === 0) {
            this.dateMatch = res.data?.sport_live_match;
          }
        }
      });
    },
    // getDateMatch(category) {
    //   // 选择赛事
    //   let { sport_type } = category || {};
    //   post({
    //     url: "/webapi/sport/getEventByDate",
    //     data: { date: moment().format("YYYY-MM-DD"), have_live: 2, sport_type },
    //   }).then(({ data: { data } }) => {
    //     this.dateMatch = data.events;
    //   });
    // },

    getLabel(key) {
      return key === "pushurl3" ? "英文高清" : key === "pushurl2" ? "中文高清" : "普清";
    },
    chooseSession(e) {
      this.formLive.session = e;
      const match = (this.dateMatch || []).find((item) => String(item.match_id) === String(e));
      if (match && match.home && match.away) {
        this.formLive.title = `${match.home} VS ${match.away}`;
        this.$nextTick(() => {
          this.$refs.formLive && this.$refs.formLive.clearValidate("title");
        });
      }
    },
    chooseDefinition() {
      this.formLive.liveStream = this.formLive.definition;
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          post({
            // 获取推流地址
            url: "/webapi/live/startLive",
            data: {
              title: this.formLive.title, //標題 必填
              category: this.formLive.category, //直播分类 必填
              cateid: this.formLive.region, //直播二级分类 必填
              stream: this.stream, //流名 必填
              stream_name: this.formLive.anchor_secret,
              thumb: this.formLive.imageUrl, //直播封面
              thumb_y: this.formLive.imageUrl_v, //直播封面
              room_type: 0, //0-普通房间 1-私密房间 2-付费房间
              anchor_secret: this.formLive.anchor_secret, //密碼
              price: 0, //價格
              start_stamp: 0, // 直播时间
              match_id: this.formLive.session || 0, //赛事id
              // match_id: 0, //赛事id
              ticket: Number(this.formLive.ticket) || 0,
              enable_webrtc: this.pushStream_webrtc_toggle ? 1 : 0,
              ticket_toogle: this.ticket_toogle ? 1 : 0,
            },
          })
            .then((result) => {
              this.loading = false;
              if (result.status === 200) {
                const res = result.data || {};
                if (res.status === 0) {
                  this.$message.success(this.$t("start-live.live-set-up-successfully"));
                  this.resetForm(formName);
                  this.$store.commit("setIsLiving", true);
                  this.$router.push("/liveMatchesTwo/" + this.userInfo.id);
                }
              }
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
            });
        }
      });
    },
    createPlanLive(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          post({
            url: "/api/live/anchor_plan_create",
            data: {
              anchor_id: this.userInfo.id,
              title: this.formLive.title, //標題 必填
              category_id: this.formLive.category, //直播分类 必填
              child_category_id: this.formLive.region, //直播二级分类 必填
              thumb: this.formLive.imageUrl, //直播封面
              plan_time: this.formLive.schedule, // 计划时间
              match_id: this.formLive.session || 0, //赛事id
              ticket: Number(this.formLive.ticket) || 0,
            },
          })
            .then((result) => {
              this.loading = false;
              if (result.status === 200) {
                const res = result.data || {};
                if (res.status === 0) {
                  this.$message.success("计划开播设置成功");
                  this.resetForm(formName);
                  this.$router.push("/user-center/live-management");
                }
              }
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
            });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      console.log("handleAvatarSuccess", file);
      // if (this.setTimer) {
      //   clearTimeout(this.setTimer);
      // }
      // this.imageUrl = URL.createObjectURL(file.raw);
      // //this.formLive.imageUrl = `https://sport.sun8tv.com${res.data[0]}`;
      // const { img_upload_url } = this.appConfig;
      // if (typeof res != "undefined" && res.status == 0 && res.data && res.data.length) {
      //   let imgurl = "";
      //   if (res.data[0]) {
      //     imgurl = `${img_upload_url}${res.data[0]}`;
      //   }
      //   this.formLive.imageUrl = imgurl;
      // }

      this.upLoading = false;

      this.$refs["formLive"].clearValidate("imageUrl");
    },
    handleAvatarSuccessVertical(res, file) {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      this.imageUrl_v = URL.createObjectURL(file.raw);
      //  this.formLive.imageUrl_v = `https://sport.sun8tv.com${res.data[0]}`;
      const { img_upload_url } = this.appConfig;
      if (typeof res != "undefined" && res.status == 0 && res.data && res.data.length) {
        let imgurl = "";
        if (res.data[0]) {
          imgurl = `${img_upload_url}${res.data[0]}`;
        }
        this.formLive.imageUrl_v = imgurl;
      }
      this.upLoading_v = false;
      this.$refs["formLive"].clearValidate("imageUrl_v");
    },

    beforeAvatarUploadVertical(file) {
      return this.beforeUpload(file, true);
    },

    handleUpload(res) {
      const file = res.file;
      console.log("handleUpload", file);

      if (this.setTimer) {
        clearTimeout(this.setTimer);
        this.setTimer = null;
      }

      this.upload(file)
        .then((res) => {
          if (res.status === 0) {
            this.formLive.imageUrl = res.data;
            this.imageUrl = res.data;
          }
        })
        .finally((err) => {
          this.$refs["formLive"].clearValidate("imageUrl");
          this.upLoading = false;
          console.log(err);
        });
    },

    beforeAvatarUpload(file) {
      return this.beforeUpload(file, false);
    },

    beforeUpload(file, flag) {
      const flieArr = file.name.split("."); // 根据.分割数组
      let suffix = flieArr[flieArr.length - 1]; // 取最后一个
      const isJPG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isBMP = file.type === "image/bmp";
      const isJpeg = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if ((!isJPG && !isGIF && !isPNG && !isBMP && !isJpeg) || suffix == "jfif") {
        this.$message.error(this.$t("start-live.uploaded-images"));
        return false;
      }
      if (!isLt2M) {
        this.$message.error(this.$t("start-live.the-size"));
        return false;
      }
      if (flag) {
        this.upLoading_v = true;
      } else {
        this.upLoading = true;
      }
      this.setTimer = setTimeout(() => {
        this.upLoading_v = false;
        this.upLoading = false;
      }, 3000);
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    removeImage(id) {
      if (id) {
        this.imageUrl_v = "";
        this.formLive.imageUrl_v = "";
      } else {
        this.imageUrl = "";
        this.formLive.imageUrl = "";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
/deep/ .el-form-item{
  margin-bottom: 15px;
}
/deep/ .el-dialog {
  background: linear-gradient(180deg, #E6F2FF 0%, #FFFFFF 57.74%);
  border-radius: 8px;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}

/deep/ .el-dialog__headerbtn {
  top: 11px;
  right: 12px;
}

/deep/ .el-upload-dragger {
  border: 1px solid #d5d5d5;
  border-radius: 3px;
  width: 296px;
  height: 166px;
  padding-top: 14px;
  line-height: 22px;
}
.title {
  display : flex;
  flex-direction: column;
   align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 0.2rem;
  font-family: PingFang SC;
  font-weight: 500;
    padding-top: 20px;

}
.upload-demo {
  width: 160px;
  height: 90px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F9F9FB;
  border: solid 1px #d5d5d5;
  border-radius: 4px;
  position: relative;

  .upload-text {
    color: var(--theme-primary);
  }
}

.upload-demo-v {
  width: 68px;
  height: 90px;
}

.imgurl {
  margin-top: 7px;
  border-radius: 4px;
}

.append_text {
  font-size: 14px;
  color: var(--theme-primary);
  cursor: pointer;
  margin-left: 11px;
}

.pull-stream {
  display: inline-block;
  width: 300px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  outline: none;
  padding: 0 15px;
  box-sizing: border-box;
}

.fcc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.del {
  width: 70px;
  position: absolute;
  top: 0;
  font-size: 14px;
  color: var(--theme-primary);
  text-align: left;
}

.el-upload__text {
  width: 200px;
  position: absolute;
  bottom: 0;
  color: #ccc;
  line-height: 22px;
  text-align: left;
}

.size {
  color: #666666;
}

.format {
  color: #999;
}

/deep/ .el-dialog__body {
  padding-bottom: 0;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 27px;
}

/deep/ .el-dialog__footer {
  padding-bottom: 20px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 10px;
}

.dialogs-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 13px;

  .btn {
    // width: 160px;
    flex: 1;
    height: 40px;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    cursor: pointer;
    box-sizing: border-box;
  }

  .cancle-btn {
    color: #5E667B;

    border-radius: 100px;
    margin-right: 24px;

    background: #F1F3F6;

  }

  .confirm_btn {
    padding: 0;
    color: #ffffff;
    background: var(--theme-primary);

    border-radius: 100px;
  }
}
</style>
